import { cloneDeep } from "lodash";
import initialState from "../../../store/initialState";
import {
  DEACTIVATE_CONNECTION_VALUE_ERROR,
  DEACTIVATE_CONNECTION_VALUE_STARTING,
  DEACTIVATE_CONNECTION_VALUE_SUCCESS,
} from "../../../constants/actionTypes";

export default function deactivateConnectionValueReducer(
  state = initialState.deactivateConnectionValue,
  action
) {
  switch (action.type) {
    case DEACTIVATE_CONNECTION_VALUE_STARTING: {
      const {connectionValueId} = action;
      const newState = cloneDeep(state);


       
      if(!newState[connectionValueId]) {
        newState[connectionValueId] = cloneDeep(initialState.deactivateConnectionValue.connectionValueId);
      }


      const memberData = newState[connectionValueId]

      memberData.saving = true;
      memberData.saved = false;
      return newState;
    }

    case DEACTIVATE_CONNECTION_VALUE_SUCCESS: {
      const { connectionValueId } = action;
      const newState = cloneDeep(state);


      if(!newState[connectionValueId]) {
        newState[connectionValueId] = cloneDeep(initialState.deactivateConnectionValue.connectionValueId);
      }

      const memberData = newState[connectionValueId]
      memberData.saving = false;
      memberData.saved = true;
      memberData.error = null;

      return newState;
    }

    case DEACTIVATE_CONNECTION_VALUE_ERROR: {
      const {connectionValueId} = action;
      const newState = cloneDeep(state);

      

      if(!newState[connectionValueId]) {
        newState[connectionValueId] = cloneDeep(initialState.deactivateConnectionValue.connectionValueId);
      }

      const memberData = newState[connectionValueId]

      memberData.saving = false;
      memberData.saved = false;
      memberData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
